import { render, staticRenderFns } from "./aptPageTab.vue?vue&type=template&id=129728dc&scoped=true"
import script from "./aptPageTab.vue?vue&type=script&lang=js"
export * from "./aptPageTab.vue?vue&type=script&lang=js"
import style0 from "./aptPageTab.vue?vue&type=style&index=0&id=129728dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129728dc",
  null
  
)

export default component.exports